<template>
  <h6 class="mt-3 mb-1">Укажите общее значение {{ getValueTypeName }} для товаров в стратегии:</h6>
  <div class="col-sm-3 mt-0">
    <input type="text" class="form-control" v-model="localValue">
  </div>
  <hr class="mt-4">
</template>

<script>

export default {
  name: 'ValueForAllProducts',
  data() {
    return {}
  },
  props: {
    value: {
      type: Number,
      default: () => 0
    },
    value_type: {
      type: String
    }
  },
  computed: {
    getValueTypeName() {
      if (this.value_type === 'profit_amount') {
        return 'прибыли'
      }
      if (this.value_type === 'profit_percent') {
        return 'процента прибыли (от цены)'
      }
      if (this.value_type === 'profit_percent_cost') {
        return 'процента прибыли (от себестоимости)'
      }
      if (this.value_type === 'price') {
        return 'цены'
      }
      return ''
    },
    localValue: {
      get() {
        return this.value
      },
      set(newValue) {
        // Convert input to a number or default to 0
        const num = parseFloat(newValue) || 0
        this.$emit('update:value', num)
      }
    }
  },
  emits: ['update:value']
}
</script>